import { makeStyles } from 'tss-react/mui';
import { spacing, typographySohne, colors } from '../../styles/jss/variables';
export const minHeights = {
    SMALL: { xs: 236, sm: 300, md: 300, lg: 300, xl: 348 },
    MEDIUM: { xs: 332, sm: 300, md: 436, lg: 436, xl: 512 },
    LARGE: { xs: 360, sm: 320, md: 478, lg: 478, xl: 824 },
};
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column-reverse',
        placeContent: 'center',
        overflow: 'hidden',
    },
    contentInner: {
        width: '100%',
        margin: `${spacing.medium}`,
        [theme.breakpoints.up('sm')]: {
            margin: `${spacing.medium} ${spacing.medium} ${spacing.medium} ${spacing.large}`,
        },
        [theme.breakpoints.up('md')]: {
            margin: `${spacing.large} ${spacing.large} ${spacing.large} ${spacing.xl}`,
        },
        '& > :last-child': {
            [theme.breakpoints.up('md')]: {
                marginBottom: '0px',
            },
        },
    },
    image: {
        '& img': {
            objectFit: 'cover',
        },
    },
    minHeightSmall: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.SMALL.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.SMALL.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.SMALL.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.SMALL.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.SMALL.xl,
            },
        },
    },
    minHeightMedium: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.MEDIUM.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.MEDIUM.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.MEDIUM.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.MEDIUM.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.MEDIUM.xl,
            },
        },
    },
    minHeightLarge: {
        [`&, & .${classes.image}`]: {
            minHeight: minHeights.LARGE.xs,
            [theme.breakpoints.up('sm')]: {
                minHeight: minHeights.LARGE.sm,
            },
            [theme.breakpoints.up('md')]: {
                minHeight: minHeights.LARGE.md,
            },
            [theme.breakpoints.up('lg')]: {
                minHeight: minHeights.LARGE.lg,
            },
            [theme.breakpoints.up('xl')]: {
                minHeight: minHeights.LARGE.xl,
            },
        },
    },
    black: {
        color: `${colors.supplementary.black}`,
    },
    white: {
        color: `${colors.supplementary.white}`,
    },
    // The below two classes remove the margin from the content on the left or right side based on which side the content is placed and the use of !important is to override the margin value defined in the contentInner
    removeContentLeftMargin: {
        [theme.breakpoints.up('sm')]: {
            marginLeft: '0px',
        },
    },
    removeContentRightMargin: {
        [theme.breakpoints.up('sm')]: {
            marginRight: '0px',
        },
    },
    headingLine: {
        alignSelf: 'flex-start',
        display: 'block',
    },
    heading: Object.assign(Object.assign(Object.assign({ width: '100%' }, typographySohne.large_bold), theme.typographySpacing.large_bold_sm), { marginBottom: `${spacing.small}`, [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, typographySohne.xxl_bold), theme.typographySpacing.xxl_bold_sm), { marginBottom: `${spacing.large}` }), [theme.breakpoints.up('xl')]: Object.assign(Object.assign(Object.assign({}, typographySohne.xxxxl), theme.typographySpacing.xxxxl_sm), { marginBottom: `${spacing.large}` }) }),
    message: {},
    fontSohne: {
        [`& .${classes.message}`]: Object.assign(Object.assign({}, typographySohne.small_regular), { marginBottom: `${spacing.large}`, [theme.breakpoints.up('sm')]: Object.assign(Object.assign(Object.assign({}, typographySohne.small_regular), theme.typographySpacing.small_bold_lg), { marginBottom: `${spacing.xs}` }), [theme.breakpoints.up('xl')]: Object.assign(Object.assign(Object.assign({}, typographySohne.medium_regular), theme.typographySpacing.medium_regular_sm), { marginBottom: `${spacing.medium}` }) }),
    },
    homeBannerRightContainer: {
        [theme.breakpoints.up('sm')]: {
            alignSelf: 'end',
        },
    },
    homeBannerLeftContainer: {
        [theme.breakpoints.up('sm')]: {
            alignSelf: 'start',
        },
    },
    content: {
        alignSelf: 'start',
        [theme.breakpoints.up('sm')]: {
            position: 'absolute',
        },
    },
    linkContainer: {
        [theme.breakpoints.up('sm')]: {
            display: 'inline-block',
            flexDirection: 'column',
        },
    },
    positionTop: {
        alignContent: 'start',
    },
    positionCenter: {
        alignContent: 'center',
    },
    positionBottom: {
        alignContent: 'end',
    },
}));
export default useStyles;
